import HouseAccounts from './HouseAccounts'

export default HouseAccounts
